import React, { Component } from "react";
import { Button, Container, Row, Form, Col, Offcanvas } from "react-bootstrap";
import { toast } from "react-toastify";
import DataTable from "react-data-table-component";
import configData from "../config.json";
import { ValidationUtils } from "../Sidebar/Common";

import LoadingOverlay from "./LoadingOverlay";
export default class Chatbotconversations extends Component {
  constructor(props) {
    super(props);
    this.state = {
      loading: false,
      loadingMessage: "Processing your request...",
      show: false,
      data: [],
      sId: sessionStorage.getItem("sessionId"),
      uId: sessionStorage.getItem("uId"),
      errors: {},
      touched: {}, // Track which fields have been touched
      filteredData: null,
      tableClms: [
        {
          name: "S.NO",
          selector: (row, i) => row.chatbotconversations_Id,
          sortable: true,
          cell: (row) => <span>{row.chatbotconversations_Id}</span>,
        },
        {
          name: "Session Id",
          selector: (row, i) => row.session_id,
          sortable: true,
          cell: (row) => <span>{row.session_id}</span>,
        },
        {
          name: "user Id",
          selector: (row, i) => row.user_id,
          sortable: true,
          cell: (row) => <span>{row.user_id}</span>,
        },
        {
          name: "User Ip",
          selector: (row, i) => row.user_ip,
          sortable: true,
          cell: (row) => <span>{row.user_ip}</span>,
        },
        {
          name: "User Agent ",
          selector: (row, i) => row.user_agent,
          sortable: true,
          cell: (row) => <span>{row.user_agent}</span>,
        },
        {
          name: "Conversation Start",
          selector: (row, i) => row.conversation_start,
          sortable: true,
          cell: (row) => <span>{row.conversation_start}</span>,
        },
        {
          name: "Conversation End",
          selector: (row, i) => row.conversation_end,
          sortable: true,
          cell: (row) => <span>{row.conversation_end}</span>,
        },
        {
          name: "Total Messages",
          selector: (row, i) => row.total_messages,
          sortable: true,
          cell: (row) => <span>{row.total_messages}</span>,
        },
        {
          name: "User Satisfaction",
          selector: (row, i) => row.user_satisfaction,
          sortable: true,
          cell: (row) => <span>{row.user_satisfaction}</span>,
        },
        {
          name: "Resolved Query",
          selector: (row, i) => row.resolved_query,
          sortable: true,
          cell: (row) => <span>{row.resolved_query}</span>,
        },
        {
          name: "Escalated To Human",
          selector: (row, i) => row.escalated_to_human,
          sortable: true,
          cell: (row) => <span>{row.escalated_to_human}</span>,
        },
        {
          name: "Conversation Summary",
          selector: (row, i) => row.conversation_summary,
          sortable: true,
          cell: (row) => <span>{row.conversation_summary}</span>,
        },
        //***tableClms
        {
          name: "Actions",
          sortable: false,
          cell: (row) => (
            <div>
              {/* edit button and delete button */}
              <Button
                style={{ marginRight: "10px" }}
                variant="primary"
                onClick={() => this.ChatbotconversationseditHandler(row)}
                className="bi bi-pen"
              ></Button>
              <Button
                variant="danger"
                onClick={() => this.handleDelete(row)}
                className="bi bi-trash danger"
              ></Button>
            </div>
          ),
        },
      ],
      currentPage: 1,
      itemsPerPage: 10,
      isEditing: false,
      chatbotconversations_Id: "",
      session_id: "",
      user_id: "",
      user_ip: "",
      user_agent: "",
      conversation_start: "",
      conversation_end: "",
      total_messages: "",
      user_satisfaction: "",
      resolved_query: "",
      escalated_to_human: "",
      conversation_summary: "",
      //***state
    };
  }

  // Enhanced validation method using Common.js with auto-generated logic
  validateField = (fieldName, value, fieldConfig) => {
    const { inputType, validationOptions } = fieldConfig;
    const fieldDisplayName = fieldConfig.displayName || fieldName;

    let validationResult = { isValid: true, message: "" };

    // Auto-generated validation based on inputType and validationOptions
    switch (inputType.toLowerCase()) {
      case "text":
        if (validationOptions?.isName) {
          validationResult = ValidationUtils.validateName(value);
        } else if (validationOptions?.isAddress) {
          validationResult = ValidationUtils.validateAddress(value);
        } else if (validationOptions?.maxLength) {
          validationResult = ValidationUtils.validateLength(
            value,
            parseInt(validationOptions.maxLength),
            fieldDisplayName
          );
        } else {
          validationResult = { isValid: true, message: "" };
        }
        break;

      case "mail":
      case "email":
        validationResult = ValidationUtils.validateEmail(value);
        break;

      case "telephone":
      case "phone":
        validationResult = ValidationUtils.validatePhone(value);
        break;

      case "number":
        validationResult = ValidationUtils.validateNumber(
          value,
          fieldDisplayName
        );
        break;

      case "dob_child":
        validationResult = ValidationUtils.validateDOBMinAge(value);
        break;

      case "dob_adult":
        validationResult = ValidationUtils.validateDOBAdult(value);
        break;

      case "pan":
        validationResult = ValidationUtils.validatePAN(value);
        break;

      case "aadhaar":
        validationResult = ValidationUtils.validateAadhaar(value);
        break;

      case "password":
        if (value.length < 6) {
          validationResult = {
            isValid: false,
            message: "Password must be at least 6 characters long",
          };
        }
        break;

      default:
        validationResult = { isValid: true, message: "" };
    }

    // Check required field validation
    if (
      validationOptions?.isRequired &&
      (!value || value.toString().trim() === "")
    ) {
      validationResult = ValidationUtils.validateRequired(
        value,
        fieldDisplayName
      );
    }

    const errors = { ...this.state.errors };
    if (!validationResult.isValid) {
      errors[fieldName] = validationResult.message;
    } else {
      delete errors[fieldName];
    }

    this.setState({ errors });
    return validationResult.isValid;
  };

  // Enhanced field change handler with auto-validation
  handleFieldChange = (fieldName, value, fieldConfig) => {
    this.setState({
      [fieldName]: value,
      touched: { ...this.state.touched, [fieldName]: true },
    });

    // Only validate if field has been touched
    if (this.state.touched[fieldName] || value !== "") {
      this.validateField(fieldName, value, fieldConfig);
    }
  };

  // Enhanced field blur handler for validation
  handleFieldBlur = (fieldName, value, fieldConfig) => {
    this.setState({
      touched: { ...this.state.touched, [fieldName]: true },
    });
    this.validateField(fieldName, value, fieldConfig);
  };

  // Check if form is valid - auto-generated based on required fields
  isFormValid = () => {
    const { errors } = this.state;

    // Auto-generated required field validation
    // No required fields defined

    return Object.keys(errors).length === 0;
  };

  // Auto-generated validation for all fields before submission
  validateAllFields = () => {
    const fieldConfigs = [
      {
        fieldName: "session_id",
        inputType: "Text",
        displayName: "Session Id",
        validationOptions: { isRequired: false, maxLength: 50 },
      },
      {
        fieldName: "user_id",
        inputType: "Number",
        displayName: "user Id",
        validationOptions: { isRequired: false, maxLength: 50 },
      },
      {
        fieldName: "user_ip",
        inputType: "Text",
        displayName: "User Ip",
        validationOptions: { isRequired: false, maxLength: 50 },
      },
      {
        fieldName: "user_agent",
        inputType: "Text",
        displayName: "User Agent ",
        validationOptions: { isRequired: false, maxLength: 50 },
      },
      {
        fieldName: "conversation_start",
        inputType: "Date",
        displayName: "Conversation Start",
        validationOptions: { isRequired: false, maxLength: 50 },
      },
      {
        fieldName: "conversation_end",
        inputType: "Date",
        displayName: "Conversation End",
        validationOptions: { isRequired: false, maxLength: 50 },
      },
      {
        fieldName: "total_messages",
        inputType: "Number",
        displayName: "Total Messages",
        validationOptions: { isRequired: false, maxLength: 50 },
      },
      {
        fieldName: "user_satisfaction",
        inputType: "Number",
        displayName: "User Satisfaction",
        validationOptions: { isRequired: false, maxLength: 50 },
      },
      {
        fieldName: "resolved_query",
        inputType: "Number",
        displayName: "Resolved Query",
        validationOptions: { isRequired: false, maxLength: 50 },
      },
      {
        fieldName: "escalated_to_human",
        inputType: "Number",
        displayName: "Escalated To Human",
        validationOptions: { isRequired: false, maxLength: 50 },
      },
      {
        fieldName: "conversation_summary",
        inputType: "Text",
        displayName: "Conversation Summary",
        validationOptions: { isRequired: false, maxLength: 50 },
      },
    ];

    fieldConfigs.forEach((config) => {
      const value = this.state[config.fieldName];
      this.validateField(config.fieldName, value, config);
    });

    const touched = {};
    fieldConfigs.forEach((config) => {
      touched[config.fieldName] = true;
    });
    this.setState({ touched });
  };

  // offcanvas Open
  handleOffcanvasShow = () => {
    this.setState({
      show: true,
      errors: {},
      touched: {},
      session_id: "",
      user_id: "",
      user_ip: "",
      user_agent: "",
      conversation_start: "",
      conversation_end: "",
      total_messages: "",
      user_satisfaction: "",
      resolved_query: "",
      escalated_to_human: "",
      conversation_summary: "",
    });
  };

  // Offcanvas close button
  handleOffcanvasClose = () => {
    this.setState({
      show: false,
      isEditing: false,
      errors: {},
      touched: {},
      session_id: "",
      user_id: "",
      user_ip: "",
      user_agent: "",
      conversation_start: "",
      conversation_end: "",
      total_messages: "",
      user_satisfaction: "",
      resolved_query: "",
      escalated_to_human: "",
      conversation_summary: "",
    });
  };

  // Enhanced toast notifications
  showToast = (msg, type) => {
    switch (type) {
      case "success":
        toast.success(msg);
        break;
      case "error":
        toast.error(msg);
        break;
      case "warning":
        toast.warn(msg);
        break;
      default:
        toast.info(msg);
    }
  };

  ChatbotconversationseditHandler = (row) => {
    this.setState({
      isEditing: true,
      show: true,
      chatbotconversations_Id: row.chatbotconversations_Id,
      session_id: row.session_id,
      user_id: row.user_id,
      user_ip: row.user_ip,
      user_agent: row.user_agent,
      conversation_start: row.conversation_start,
      conversation_end: row.conversation_end,
      total_messages: row.total_messages,
      user_satisfaction: row.user_satisfaction,
      resolved_query: row.resolved_query,
      escalated_to_human: row.escalated_to_human,
      conversation_summary: row.conversation_summary,
      //***editstate
      errors: {},
      touched: {},
    });
  };

  ChatbotconversationsfetchHandler = () => {
    var formData = new FormData();
    formData.append("sId", this.state.sId);
    formData.append("uId", this.state.uId);

    fetch(configData.api_url + "C_Chatbotconversations/list", {
      method: "POST",
      mode: "cors",
      body: formData,
    })
      .then((response) => response.json())
      .then((data) => {
        if (data.status === "success") {
          this.setState({ data: data.list });
        }
      })
      .catch((error) => {
        console.error("Fetch error:", error);
        this.showToast("Failed to load data", "error");
      });
  };

  ChatbotconversationssubmitHandler = (e) => {
    e.preventDefault();

    // Validate all fields before submission
    this.validateAllFields();

    if (!this.isFormValid()) {
      this.showToast("Please fix all errors before submitting", "error");
      return;
    }

    var formData = new FormData();
    formData.append("sId", this.state.sId);
    formData.append("uId", this.state.uId);
    formData.append("session_id", this.state.session_id);
    formData.append("user_id", this.state.user_id);
    formData.append("user_ip", this.state.user_ip);
    formData.append("user_agent", this.state.user_agent);
    formData.append("conversation_start", this.state.conversation_start);
    formData.append("conversation_end", this.state.conversation_end);
    formData.append("total_messages", this.state.total_messages);
    formData.append("user_satisfaction", this.state.user_satisfaction);
    formData.append("resolved_query", this.state.resolved_query);
    formData.append("escalated_to_human", this.state.escalated_to_human);
    formData.append("conversation_summary", this.state.conversation_summary);

    //***tableData*

    this.setState({ loading: true, loadingMessage: "Saving..." });
    fetch(configData.api_url + "C_Chatbotconversations/add", {
      method: "POST",
      mode: "cors",
      body: formData,
    })
      .then((response) => response.json())
      .then((data) => {
        this.showToast(data.message, data.status);
        if (data.status === "success") {
          this.ChatbotconversationsfetchHandler();
          this.handleOffcanvasClose();
          this.setState({
            session_id: "",
            user_id: "",
            user_ip: "",
            user_agent: "",
            conversation_start: "",
            conversation_end: "",
            total_messages: "",
            user_satisfaction: "",
            resolved_query: "",
            escalated_to_human: "",
            conversation_summary: "",
          });
        }
      
        this.setState({ loading: false });})
      .catch((error) => {
        console.error("Submit error:", error);
        this.showToast("Failed to save data", "error");
      
        this.setState({ loading: false });});
  };

  ChatbotconversationsupdateHandler = (e) => {
    e.preventDefault();

    // Validate all fields before submission
    this.validateAllFields();

    if (!this.isFormValid()) {
      this.showToast("Please fix all errors before updating", "error");
      return;
    }

    var formData = new FormData();
    formData.append("sId", this.state.sId);
    formData.append("uId", this.state.uId);
    formData.append(
      "chatbotconversations_Id",
      this.state.chatbotconversations_Id
    );
    formData.append("session_id", this.state.session_id);
    formData.append("user_id", this.state.user_id);
    formData.append("user_ip", this.state.user_ip);
    formData.append("user_agent", this.state.user_agent);
    formData.append("conversation_start", this.state.conversation_start);
    formData.append("conversation_end", this.state.conversation_end);
    formData.append("total_messages", this.state.total_messages);
    formData.append("user_satisfaction", this.state.user_satisfaction);
    formData.append("resolved_query", this.state.resolved_query);
    formData.append("escalated_to_human", this.state.escalated_to_human);
    formData.append("conversation_summary", this.state.conversation_summary);

    //***tableData1

    this.setState({ loading: true, loadingMessage: "Updating..." });
    fetch(configData.api_url + "C_Chatbotconversations/update", {
      method: "POST",
      mode: "cors",
      body: formData,
    })
      .then((response) => response.json())
      .then((data) => {
        this.showToast(data.message, data.status);
        if (data.status === "success") {
          this.ChatbotconversationsfetchHandler();
          this.handleOffcanvasClose();
        }
      
        this.setState({ loading: false });})
      .catch((error) => {
        console.error("Update error:", error);
        this.showToast("Failed to update data", "error");
      
        this.setState({ loading: false });});
  };

  componentDidMount() {
    this.ChatbotconversationsfetchHandler();

    //***componentDidMount
  }

  handlesession_idChange = (e) => {
    e.preventDefault();
    const fieldValue = e.target.value;
    this.setState({ session_id: fieldValue });
  };
  handleuser_idChange = (e) => {
    e.preventDefault();
    const fieldValue = e.target.value;
    this.setState({ user_id: fieldValue });
  };
  handleuser_ipChange = (e) => {
    e.preventDefault();
    const fieldValue = e.target.value;
    this.setState({ user_ip: fieldValue });
  };
  handleuser_agentChange = (e) => {
    e.preventDefault();
    const fieldValue = e.target.value;
    this.setState({ user_agent: fieldValue });
  };
  handleconversation_startChange = (e) => {
    e.preventDefault();

    const fieldValue = e.target.value;
    this.setState({ conversation_start: fieldValue });
  };
  handleconversation_endChange = (e) => {
    e.preventDefault();

    const fieldValue = e.target.value;
    this.setState({ conversation_end: fieldValue });
  };
  handletotal_messagesChange = (e) => {
    e.preventDefault();
    const fieldValue = e.target.value;
    this.setState({ total_messages: fieldValue });
  };
  handleuser_satisfactionChange = (e) => {
    e.preventDefault();
    const fieldValue = e.target.value;
    this.setState({ user_satisfaction: fieldValue });
  };
  handleresolved_queryChange = (e) => {
    e.preventDefault();
    const fieldValue = e.target.value;
    this.setState({ resolved_query: fieldValue });
  };
  handleescalated_to_humanChange = (e) => {
    e.preventDefault();
    const fieldValue = e.target.value;
    this.setState({ escalated_to_human: fieldValue });
  };
  handleconversation_summaryChange = (e) => {
    e.preventDefault();
    const fieldValue = e.target.value;
    this.setState({ conversation_summary: fieldValue });
  };
  //***inputFunctions

  handleRowSelect = (row) => {
    this.setState({
      selectedRow: row.index,
    });
  };

  handleRowUpdate = (newData, oldData) => {
    const data = [...this.state.data];
    const index = oldData.index;
    data[index] = newData;
    this.setState({ data });
  };

  handleEdit = (row) => {
    console.log(`Editing row with ID ${row.id}`);
  };

  handleDelete = (row, index) => {
    if (
      !window.confirm(
        `Are you sure you want to delete this chatbotconversations?`
      )
    ) {
      return;
    }

    var formData = new FormData();
    formData.append("chatbotconversations_Id", row.chatbotconversations_Id);

    this.setState({ loading: true, loadingMessage: "Deleting..." });
    fetch(configData.api_url + "C_Chatbotconversations/delete", {
      method: "POST",
      mode: "cors",
      body: formData,
    })
      .then((response) => response.json())
      .then((data) => {
        this.showToast(data.message, data.status);
        if (data.status === "success") {
          this.ChatbotconversationsfetchHandler();
        }
      
        this.setState({ loading: false });})
      .catch((error) => {
        console.error("Delete error:", error);
        this.showToast("Failed to delete data", "error");
      
        this.setState({ loading: false });});
  };

  handlePageChange = (page) => {
    this.setState({ currentPage: page });
  };

  handlePerRowsChange = (newPerPage, page) => {
    this.setState({ itemsPerPage: newPerPage, currentPage: page });
  };

  handleFilter = (e) => {
    const searchValue = e.target.value.toLowerCase();
    const filteredData = this.state.data.filter((row) => {
      return Object.values(row).join(" ").toLowerCase().includes(searchValue);
    });
    this.setState({ filteredData });
  };

  // Helper method to render error message
  renderFieldError = (fieldName) => {
    const { errors, touched } = this.state;
    if (errors[fieldName] && touched[fieldName]) {
      return (
        <div className="text-danger mt-1" style={{ fontSize: "0.875rem" }}>
          <i className="bi bi-exclamation-circle me-1"></i>
          {errors[fieldName]}
        </div>
      );
    }
    return null;
  };

  // Auto-generated form field renderer based on inputType and validation options
  renderFormField = (fieldConfig) => {
    const { fieldName, displayName, inputType, validationOptions } =
      fieldConfig;
    const value = this.state[fieldName] || "";
    const hasError =
      this.state.errors[fieldName] && this.state.touched[fieldName];

    let inputElement;

    switch (inputType.toLowerCase()) {
      case "dob_child":
      case "dob_adult":
      case "date":
        inputElement = (
          <Form.Control
            type="date"
            value={value}
            onChange={(e) =>
              this.handleFieldChange(fieldName, e.target.value, fieldConfig)
            }
            onBlur={(e) =>
              this.handleFieldBlur(fieldName, e.target.value, fieldConfig)
            }
            isInvalid={hasError}
            required={validationOptions?.isRequired}
          />
        );
        break;

      case "telephone":
      case "phone":
        inputElement = (
          <Form.Control
            type="tel"
            value={value}
            onChange={(e) =>
              this.handleFieldChange(fieldName, e.target.value, fieldConfig)
            }
            onBlur={(e) =>
              this.handleFieldBlur(fieldName, e.target.value, fieldConfig)
            }
            isInvalid={hasError}
            required={validationOptions?.isRequired}
            placeholder="Enter 10-digit mobile number"
          />
        );
        break;

      case "mail":
      case "email":
        inputElement = (
          <Form.Control
            type="email"
            value={value}
            onChange={(e) =>
              this.handleFieldChange(fieldName, e.target.value, fieldConfig)
            }
            onBlur={(e) =>
              this.handleFieldBlur(fieldName, e.target.value, fieldConfig)
            }
            isInvalid={hasError}
            required={validationOptions?.isRequired}
            placeholder="Enter email address"
          />
        );
        break;

      case "password":
        inputElement = (
          <Form.Control
            type="password"
            value={value}
            onChange={(e) =>
              this.handleFieldChange(fieldName, e.target.value, fieldConfig)
            }
            onBlur={(e) =>
              this.handleFieldBlur(fieldName, e.target.value, fieldConfig)
            }
            isInvalid={hasError}
            required={validationOptions?.isRequired}
            placeholder="Enter password"
          />
        );
        break;

      case "number":
        inputElement = (
          <Form.Control
            type="number"
            value={value}
            onChange={(e) =>
              this.handleFieldChange(fieldName, e.target.value, fieldConfig)
            }
            onBlur={(e) =>
              this.handleFieldBlur(fieldName, e.target.value, fieldConfig)
            }
            isInvalid={hasError}
            required={validationOptions?.isRequired}
            placeholder={`Enter ${displayName.toLowerCase()}`}
          />
        );
        break;

      case "pan":
        inputElement = (
          <Form.Control
            type="text"
            value={value}
            onChange={(e) =>
              this.handleFieldChange(
                fieldName,
                e.target.value.toUpperCase(),
                fieldConfig
              )
            }
            onBlur={(e) =>
              this.handleFieldBlur(fieldName, e.target.value, fieldConfig)
            }
            isInvalid={hasError}
            required={validationOptions?.isRequired}
            placeholder="ABCPA1234B"
            maxLength="10"
          />
        );
        break;

      case "aadhaar":
        inputElement = (
          <Form.Control
            type="text"
            value={value}
            onChange={(e) =>
              this.handleFieldChange(
                fieldName,
                e.target.value.replace(/\D/g, ""),
                fieldConfig
              )
            }
            onBlur={(e) =>
              this.handleFieldBlur(fieldName, e.target.value, fieldConfig)
            }
            isInvalid={hasError}
            required={validationOptions?.isRequired}
            placeholder="123456789012"
            maxLength="12"
          />
        );
        break;

      default: // text and other types
        inputElement = (
          <Form.Control
            type="text"
            value={value}
            onChange={(e) =>
              this.handleFieldChange(fieldName, e.target.value, fieldConfig)
            }
            onBlur={(e) =>
              this.handleFieldBlur(fieldName, e.target.value, fieldConfig)
            }
            isInvalid={hasError}
            required={validationOptions?.isRequired}
            placeholder={`Enter ${displayName.toLowerCase()}`}
            maxLength={validationOptions?.maxLength || undefined}
          />
        );
    }

    return (
      <Row key={fieldName}>
        <Col lg="4" md="4">
          <Form.Label>
            {displayName}
            {validationOptions?.isRequired && (
              <span className="text-danger">*</span>
            )}
          </Form.Label>
        </Col>
        <Col lg="8" md="8">
          {inputElement}
          {this.renderFieldError(fieldName)}
        </Col>
      </Row>
    );
  };

  render() {
    const { errors, touched } = this.state;

    const paginatedData = this.state.filteredData
      ? this.state.filteredData.slice(
        (this.state.currentPage - 1) * this.state.itemsPerPage,
        this.state.currentPage * this.state.itemsPerPage
      )
      : this.state.data.slice(
        (this.state.currentPage - 1) * this.state.itemsPerPage,
        this.state.currentPage * this.state.itemsPerPage
      );

    return (
      <div className="page-title">
        <LoadingOverlay show={this.state.loading} message={this.state.loadingMessage} />
        <div className="row">
          <div className="col-md-12 col-sm-12 col-xs-12">
            <div className="x_panel">
              <div className="x_content">
                <div
                  id="datatable_wrapper"
                  className="dataTables_wrapper form-inline
                dt-bootstrap no-footer"
                >
                  <Row className="row">
                    <div>
                      <h3
                        className="logoskybluecolor"
                        style={{ textAlign: "start" }}
                      >
                        Chat Bot Conversations
                      </h3>
                    </div>
                    <Col
                      className="d-flex justify-content-end"
                      style={{ marginRight: "5px", marginTop: "20px" }}
                    >
                      <Button
                        variant="primary"
                        style={{ float: "right", marginBottom: "10px" }}
                        className="bi bi-plus "
                        onClick={this.handleOffcanvasShow}
                      >
                        New
                      </Button>

                      {/* Enhanced Add Offcanvas */}
                      <Offcanvas
                        show={this.state.show && !this.state.isEditing}
                        onHide={this.handleOffcanvasClose}
                        {...this.props}
                        style={{ width: "500px" }}
                        placement="end"
                        backdrop="true"
                      >
                        <Offcanvas.Header closeButton>
                          <Offcanvas.Title>
                            Add Chatbotconversations
                          </Offcanvas.Title>
                        </Offcanvas.Header>
                        <Offcanvas.Body>
                          <Container
                            style={{ overflowY: "auto", height: "auto" }}
                          >
                            {/* Error Summary */}
                            {Object.keys(errors).length > 0 && (
                              <div className="alert alert-danger mb-3">
                                <strong>
                                  Please fix the following errors:
                                </strong>
                                <ul className="mb-0 mt-2">
                                  {Object.entries(errors).map(
                                    ([field, error]) => (
                                      <li key={field}>{error}</li>
                                    )
                                  )}
                                </ul>
                              </div>
                            )}

                            <Row className="divstyle">
                              <Row>
                                <Form>
                                  <Row>
                                    <Col lg="4" md="4">
                                      <Form.Label style={{ paddingTop: "8px" }}>
                                        Session Id
                                      </Form.Label>
                                    </Col>
                                    <Col lg="8" md="8">
                                      <Form.Control
                                        type="text"
                                        onChange={this.handlesession_idChange}
                                        className="form-control"
                                        name="session_id"
                                        value={this.state.session_id}
                                        required="required"
                                        placeholder="Enter Session Id"
                                      />
                                    </Col>
                                    <div
                                      className="errorMsg"
                                      style={{ color: "red" }}
                                    >
                                      {" "}
                                      {this.state.errors.session_id}{" "}
                                    </div>
                                  </Row>
                                  <br />
                                  <Row>
                                    <Col lg="4" md="4">
                                      <Form.Label style={{ paddingTop: "8px" }}>
                                        user Id
                                      </Form.Label>
                                    </Col>
                                    <Col lg="8" md="8">
                                      <Form.Control
                                        type="number"
                                        onChange={this.handleuser_idChange}
                                        className="form-control"
                                        name="user_id"
                                        value={this.state.user_id}
                                        required="required"
                                        placeholder="Enter user Id"
                                      />
                                    </Col>
                                    <div
                                      className="errorMsg"
                                      style={{ color: "red" }}
                                    >
                                      {" "}
                                      {this.state.errors.user_id}{" "}
                                    </div>
                                  </Row>
                                  <br />
                                  <Row>
                                    <Col lg="4" md="4">
                                      <Form.Label style={{ paddingTop: "8px" }}>
                                        User Ip
                                      </Form.Label>
                                    </Col>
                                    <Col lg="8" md="8">
                                      <Form.Control
                                        type="text"
                                        onChange={this.handleuser_ipChange}
                                        className="form-control"
                                        name="user_ip"
                                        value={this.state.user_ip}
                                        required="required"
                                        placeholder="Enter User Ip"
                                      />
                                    </Col>
                                    <div
                                      className="errorMsg"
                                      style={{ color: "red" }}
                                    >
                                      {" "}
                                      {this.state.errors.user_ip}{" "}
                                    </div>
                                  </Row>
                                  <br />
                                  <Row>
                                    <Col lg="4" md="4">
                                      <Form.Label style={{ paddingTop: "8px" }}>
                                        User Agent{" "}
                                      </Form.Label>
                                    </Col>
                                    <Col lg="8" md="8">
                                      <Form.Control
                                        type="text"
                                        onChange={this.handleuser_agentChange}
                                        className="form-control"
                                        name="user_agent"
                                        value={this.state.user_agent}
                                        required="required"
                                        placeholder="Enter User Agent "
                                      />
                                    </Col>
                                    <div
                                      className="errorMsg"
                                      style={{ color: "red" }}
                                    >
                                      {" "}
                                      {this.state.errors.user_agent}{" "}
                                    </div>
                                  </Row>
                                  <br />
                                  <Row>
                                    <Col lg="4" md="4">
                                      <Form.Label style={{ paddingTop: "8px" }}>
                                        Conversation Start
                                      </Form.Label>
                                    </Col>
                                    <Col lg="8" md="8">
                                      <Form.Control
                                        type="date"
                                        onChange={
                                          this.handleconversation_startChange
                                        }
                                        className="form-control"
                                        name="conversation_start"
                                        value={this.state.conversation_start}
                                        required="required"
                                        placeholder="Enter Conversation Start"
                                      />
                                    </Col>
                                    <div
                                      className="errorMsg"
                                      style={{ color: "red" }}
                                    >
                                      {" "}
                                      {
                                        this.state.errors.conversation_start
                                      }{" "}
                                    </div>
                                  </Row>
                                  <br />
                                  <Row>
                                    <Col lg="4" md="4">
                                      <Form.Label style={{ paddingTop: "8px" }}>
                                        Conversation End
                                      </Form.Label>
                                    </Col>
                                    <Col lg="8" md="8">
                                      <Form.Control
                                        type="date"
                                        onChange={
                                          this.handleconversation_endChange
                                        }
                                        className="form-control"
                                        name="conversation_end"
                                        value={this.state.conversation_end}
                                        required="required"
                                        placeholder="Enter Conversation End"
                                      />
                                    </Col>
                                    <div
                                      className="errorMsg"
                                      style={{ color: "red" }}
                                    >
                                      {" "}
                                      {this.state.errors.conversation_end}{" "}
                                    </div>
                                  </Row>
                                  <br />
                                  <Row>
                                    <Col lg="4" md="4">
                                      <Form.Label style={{ paddingTop: "8px" }}>
                                        Total Messages
                                      </Form.Label>
                                    </Col>
                                    <Col lg="8" md="8">
                                      <Form.Control
                                        type="number"
                                        onChange={
                                          this.handletotal_messagesChange
                                        }
                                        className="form-control"
                                        name="total_messages"
                                        value={this.state.total_messages}
                                        required="required"
                                        placeholder="Enter Total Messages"
                                      />
                                    </Col>
                                    <div
                                      className="errorMsg"
                                      style={{ color: "red" }}
                                    >
                                      {" "}
                                      {this.state.errors.total_messages}{" "}
                                    </div>
                                  </Row>
                                  <br />
                                  <Row>
                                    <Col lg="4" md="4">
                                      <Form.Label style={{ paddingTop: "8px" }}>
                                        User Satisfaction
                                      </Form.Label>
                                    </Col>
                                    <Col lg="8" md="8">
                                      <Form.Control
                                        type="number"
                                        onChange={
                                          this.handleuser_satisfactionChange
                                        }
                                        className="form-control"
                                        name="user_satisfaction"
                                        value={this.state.user_satisfaction}
                                        required="required"
                                        placeholder="Enter User Satisfaction"
                                      />
                                    </Col>
                                    <div
                                      className="errorMsg"
                                      style={{ color: "red" }}
                                    >
                                      {" "}
                                      {this.state.errors.user_satisfaction}{" "}
                                    </div>
                                  </Row>
                                  <br />
                                  <Row>
                                    <Col lg="4" md="4">
                                      <Form.Label style={{ paddingTop: "8px" }}>
                                        Resolved Query
                                      </Form.Label>
                                    </Col>
                                    <Col lg="8" md="8">
                                      <Form.Control
                                        type="number"
                                        onChange={
                                          this.handleresolved_queryChange
                                        }
                                        className="form-control"
                                        name="resolved_query"
                                        value={this.state.resolved_query}
                                        required="required"
                                        placeholder="Enter Resolved Query"
                                      />
                                    </Col>
                                    <div
                                      className="errorMsg"
                                      style={{ color: "red" }}
                                    >
                                      {" "}
                                      {this.state.errors.resolved_query}{" "}
                                    </div>
                                  </Row>
                                  <br />
                                  <Row>
                                    <Col lg="4" md="4">
                                      <Form.Label style={{ paddingTop: "8px" }}>
                                        Escalated To Human
                                      </Form.Label>
                                    </Col>
                                    <Col lg="8" md="8">
                                      <Form.Control
                                        type="number"
                                        onChange={
                                          this.handleescalated_to_humanChange
                                        }
                                        className="form-control"
                                        name="escalated_to_human"
                                        value={this.state.escalated_to_human}
                                        required="required"
                                        placeholder="Enter Escalated To Human"
                                      />
                                    </Col>
                                    <div
                                      className="errorMsg"
                                      style={{ color: "red" }}
                                    >
                                      {" "}
                                      {
                                        this.state.errors.escalated_to_human
                                      }{" "}
                                    </div>
                                  </Row>
                                  <br />
                                  <Row>
                                    <Col lg="4" md="4">
                                      <Form.Label style={{ paddingTop: "8px" }}>
                                        Conversation Summary
                                      </Form.Label>
                                    </Col>
                                    <Col lg="8" md="8">
                                      <Form.Control
                                        type="text"
                                        onChange={
                                          this.handleconversation_summaryChange
                                        }
                                        className="form-control"
                                        name="conversation_summary"
                                        value={this.state.conversation_summary}
                                        required="required"
                                        placeholder="Enter Conversation Summary"
                                      />
                                    </Col>
                                    <div
                                      className="errorMsg"
                                      style={{ color: "red" }}
                                    >
                                      {" "}
                                      {
                                        this.state.errors.conversation_summary
                                      }{" "}
                                    </div>
                                  </Row>
                                  <br />
                                  {/* Auto-generated form content with validation */}
                                </Form>
                              </Row>
                            </Row>
                            <Row>
                              <Col
                                className="d-flex justify-content-end"
                                style={{ marginRight: "50px" }}
                              >
                                <Button
                                  className="button"
                                  variant="success"
                                  onClick={
                                    this.ChatbotconversationssubmitHandler
                                  }
                                  disabled={!this.isFormValid()}
                                  style={{
                                    marginTop: "20px",
                                  }}
                                >
                                  Save
                                </Button>
                              </Col>
                            </Row>
                          </Container>
                        </Offcanvas.Body>
                      </Offcanvas>

                      {/* Enhanced Edit Offcanvas */}
                      {this.state.isEditing && (
                        <Offcanvas
                          show={this.state.isEditing}
                          onHide={this.handleOffcanvasClose}
                          {...this.props}
                          style={{ width: "500px" }}
                          placement="end"
                          backdrop="true"
                        >
                          <Offcanvas.Header closeButton>
                            <Offcanvas.Title>
                              Edit Chatbotconversations
                            </Offcanvas.Title>
                          </Offcanvas.Header>
                          <Offcanvas.Body>
                            <Container
                              style={{ overflowY: "auto", height: "auto" }}
                            >
                              {/* Error Summary */}
                              {Object.keys(errors).length > 0 && (
                                <div className="alert alert-danger mb-3">
                                  <strong>
                                    Please fix the following errors:
                                  </strong>
                                  <ul className="mb-0 mt-2">
                                    {Object.entries(errors).map(
                                      ([field, error]) => (
                                        <li key={field}>{error}</li>
                                      )
                                    )}
                                  </ul>
                                </div>
                              )}

                              <Row className="divstyle">
                                <Row>
                                  <Form>
                                    <Row>
                                      <Col lg="4" md="4">
                                        <Form.Label
                                          style={{ paddingTop: "8px" }}
                                        >
                                          Session Id
                                        </Form.Label>
                                      </Col>
                                      <Col lg="8" md="8">
                                        <Form.Control
                                          type="text"
                                          onChange={this.handlesession_idChange}
                                          className="form-control"
                                          name="session_id"
                                          value={this.state.session_id}
                                          required="required"
                                          placeholder="Enter Session Id"
                                        />
                                      </Col>
                                      <div
                                        className="errorMsg"
                                        style={{ color: "red" }}
                                      >
                                        {" "}
                                        {this.state.errors.session_id}{" "}
                                      </div>
                                    </Row>
                                    <br />
                                    <Row>
                                      <Col lg="4" md="4">
                                        <Form.Label
                                          style={{ paddingTop: "8px" }}
                                        >
                                          user Id
                                        </Form.Label>
                                      </Col>
                                      <Col lg="8" md="8">
                                        <Form.Control
                                          type="number"
                                          onChange={this.handleuser_idChange}
                                          className="form-control"
                                          name="user_id"
                                          value={this.state.user_id}
                                          required="required"
                                          placeholder="Enter user Id"
                                        />
                                      </Col>
                                      <div
                                        className="errorMsg"
                                        style={{ color: "red" }}
                                      >
                                        {" "}
                                        {this.state.errors.user_id}{" "}
                                      </div>
                                    </Row>
                                    <br />
                                    <Row>
                                      <Col lg="4" md="4">
                                        <Form.Label
                                          style={{ paddingTop: "8px" }}
                                        >
                                          User Ip
                                        </Form.Label>
                                      </Col>
                                      <Col lg="8" md="8">
                                        <Form.Control
                                          type="text"
                                          onChange={this.handleuser_ipChange}
                                          className="form-control"
                                          name="user_ip"
                                          value={this.state.user_ip}
                                          required="required"
                                          placeholder="Enter User Ip"
                                        />
                                      </Col>
                                      <div
                                        className="errorMsg"
                                        style={{ color: "red" }}
                                      >
                                        {" "}
                                        {this.state.errors.user_ip}{" "}
                                      </div>
                                    </Row>
                                    <br />
                                    <Row>
                                      <Col lg="4" md="4">
                                        <Form.Label
                                          style={{ paddingTop: "8px" }}
                                        >
                                          User Agent{" "}
                                        </Form.Label>
                                      </Col>
                                      <Col lg="8" md="8">
                                        <Form.Control
                                          type="text"
                                          onChange={this.handleuser_agentChange}
                                          className="form-control"
                                          name="user_agent"
                                          value={this.state.user_agent}
                                          required="required"
                                          placeholder="Enter User Agent "
                                        />
                                      </Col>
                                      <div
                                        className="errorMsg"
                                        style={{ color: "red" }}
                                      >
                                        {" "}
                                        {this.state.errors.user_agent}{" "}
                                      </div>
                                    </Row>
                                    <br />
                                    <Row>
                                      <Col lg="4" md="4">
                                        <Form.Label
                                          style={{ paddingTop: "8px" }}
                                        >
                                          Conversation Start
                                        </Form.Label>
                                      </Col>
                                      <Col lg="8" md="8">
                                        <Form.Control
                                          type="date"
                                          onChange={
                                            this.handleconversation_startChange
                                          }
                                          className="form-control"
                                          name="conversation_start"
                                          value={this.state.conversation_start}
                                          required="required"
                                          placeholder="Enter Conversation Start"
                                        />
                                      </Col>
                                      <div
                                        className="errorMsg"
                                        style={{ color: "red" }}
                                      >
                                        {" "}
                                        {
                                          this.state.errors.conversation_start
                                        }{" "}
                                      </div>
                                    </Row>
                                    <br />
                                    <Row>
                                      <Col lg="4" md="4">
                                        <Form.Label
                                          style={{ paddingTop: "8px" }}
                                        >
                                          Conversation End
                                        </Form.Label>
                                      </Col>
                                      <Col lg="8" md="8">
                                        <Form.Control
                                          type="date"
                                          onChange={
                                            this.handleconversation_endChange
                                          }
                                          className="form-control"
                                          name="conversation_end"
                                          value={this.state.conversation_end}
                                          required="required"
                                          placeholder="Enter Conversation End"
                                        />
                                      </Col>
                                      <div
                                        className="errorMsg"
                                        style={{ color: "red" }}
                                      >
                                        {" "}
                                        {
                                          this.state.errors.conversation_end
                                        }{" "}
                                      </div>
                                    </Row>
                                    <br />
                                    <Row>
                                      <Col lg="4" md="4">
                                        <Form.Label
                                          style={{ paddingTop: "8px" }}
                                        >
                                          Total Messages
                                        </Form.Label>
                                      </Col>
                                      <Col lg="8" md="8">
                                        <Form.Control
                                          type="number"
                                          onChange={
                                            this.handletotal_messagesChange
                                          }
                                          className="form-control"
                                          name="total_messages"
                                          value={this.state.total_messages}
                                          required="required"
                                          placeholder="Enter Total Messages"
                                        />
                                      </Col>
                                      <div
                                        className="errorMsg"
                                        style={{ color: "red" }}
                                      >
                                        {" "}
                                        {this.state.errors.total_messages}{" "}
                                      </div>
                                    </Row>
                                    <br />
                                    <Row>
                                      <Col lg="4" md="4">
                                        <Form.Label
                                          style={{ paddingTop: "8px" }}
                                        >
                                          User Satisfaction
                                        </Form.Label>
                                      </Col>
                                      <Col lg="8" md="8">
                                        <Form.Control
                                          type="number"
                                          onChange={
                                            this.handleuser_satisfactionChange
                                          }
                                          className="form-control"
                                          name="user_satisfaction"
                                          value={this.state.user_satisfaction}
                                          required="required"
                                          placeholder="Enter User Satisfaction"
                                        />
                                      </Col>
                                      <div
                                        className="errorMsg"
                                        style={{ color: "red" }}
                                      >
                                        {" "}
                                        {
                                          this.state.errors.user_satisfaction
                                        }{" "}
                                      </div>
                                    </Row>
                                    <br />
                                    <Row>
                                      <Col lg="4" md="4">
                                        <Form.Label
                                          style={{ paddingTop: "8px" }}
                                        >
                                          Resolved Query
                                        </Form.Label>
                                      </Col>
                                      <Col lg="8" md="8">
                                        <Form.Control
                                          type="number"
                                          onChange={
                                            this.handleresolved_queryChange
                                          }
                                          className="form-control"
                                          name="resolved_query"
                                          value={this.state.resolved_query}
                                          required="required"
                                          placeholder="Enter Resolved Query"
                                        />
                                      </Col>
                                      <div
                                        className="errorMsg"
                                        style={{ color: "red" }}
                                      >
                                        {" "}
                                        {this.state.errors.resolved_query}{" "}
                                      </div>
                                    </Row>
                                    <br />
                                    <Row>
                                      <Col lg="4" md="4">
                                        <Form.Label
                                          style={{ paddingTop: "8px" }}
                                        >
                                          Escalated To Human
                                        </Form.Label>
                                      </Col>
                                      <Col lg="8" md="8">
                                        <Form.Control
                                          type="number"
                                          onChange={
                                            this.handleescalated_to_humanChange
                                          }
                                          className="form-control"
                                          name="escalated_to_human"
                                          value={this.state.escalated_to_human}
                                          required="required"
                                          placeholder="Enter Escalated To Human"
                                        />
                                      </Col>
                                      <div
                                        className="errorMsg"
                                        style={{ color: "red" }}
                                      >
                                        {" "}
                                        {
                                          this.state.errors.escalated_to_human
                                        }{" "}
                                      </div>
                                    </Row>
                                    <br />
                                    <Row>
                                      <Col lg="4" md="4">
                                        <Form.Label
                                          style={{ paddingTop: "8px" }}
                                        >
                                          Conversation Summary
                                        </Form.Label>
                                      </Col>
                                      <Col lg="8" md="8">
                                        <Form.Control
                                          type="text"
                                          onChange={
                                            this
                                              .handleconversation_summaryChange
                                          }
                                          className="form-control"
                                          name="conversation_summary"
                                          value={
                                            this.state.conversation_summary
                                          }
                                          required="required"
                                          placeholder="Enter Conversation Summary"
                                        />
                                      </Col>
                                      <div
                                        className="errorMsg"
                                        style={{ color: "red" }}
                                      >
                                        {" "}
                                        {
                                          this.state.errors.conversation_summary
                                        }{" "}
                                      </div>
                                    </Row>
                                    <br />
                                    {/* Auto-generated form content with validation */}
                                  </Form>
                                </Row>
                              </Row>
                              <Row>
                                <Col
                                  className="d-flex justify-content-end"
                                  style={{ marginRight: "50px" }}
                                >
                                  <Button
                                    className="button"
                                    variant="success"
                                    onClick={
                                      this.ChatbotconversationsupdateHandler
                                    }
                                    disabled={!this.isFormValid()}
                                    style={{
                                      marginTop: "20px",
                                    }}
                                  >
                                    Update
                                  </Button>
                                </Col>
                              </Row>
                            </Container>
                          </Offcanvas.Body>
                        </Offcanvas>
                      )}
                      {/*offcanvas is over */}
                    </Col>
                  </Row>
                  <br />
                  <Row>
                    <div style={{ marginRight: "5px" }}>
                      {/* searchbar,pagination,filter */}
                      <input
                        type="text"
                        style={{ float: "left", marginBottom: "10px" }}
                        onChange={this.handleFilter}
                        placeholder="Search..."
                      />
                      <DataTable
                        data={paginatedData}
                        columns={this.state.tableClms}
                        pagination
                        paginationServer
                        paginationTotalRows={
                          this.state.filteredData
                            ? this.state.filteredData.length
                            : this.state.data.length
                        }
                        onChangeRowsPerPage={this.handlePerRowsChange}
                        onChangePage={this.handlePageChange}
                        paginationRowsPerPageOptions={[100, 200, 300, 400, 500, 600, 700, 800, 900, 1000]}
                        paginationPerPage={100}
                        keyField="id"
                        className="table table-striped table-bordered dataTable no-footer employeesTableIcons"
                      />
                    </div>
                  </Row>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}
